import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index/index'
import Welcome from '@/components/welcome/welcome'
import Students from '@/components/students/students-list'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/index',
      component: Index,
      children: [
        {
          path: '/',
          component: Welcome
        },
        {
          path: '/students',
          name: '学生管理',
          component: Students
        },
        {
          path: '/addStudent',
          name: '新学生',
          component: resolve => require(['@/components/students/add'], resolve)
        },
        {
          path: '/detail/:id',
          name: '详情',
          component: resolve => require(['@/components/students/detail'], resolve)
        },
        {
          path: '/scorestandard',
          name: '评分标准',
          component: resolve => require(['@/components/school-score-standard/school-score-standard'], resolve)
        },
        {
          path: '/projectweight',
          name: '项目权重',
          component: resolve => require(['@/components/school-project-weight/school-project-weight'], resolve)
        },
        {
          path: '/dataCollection',
          name: '体适能数据汇总',
          component: resolve => require(['@/components/data-collection/data-collection'], resolve)
        },
        {
          path: '/dataAnalysis',
          name: '体测分析',
          component: resolve => require(['@/components/data-test-analysis/data-test-analysis'], resolve)
        },
        {
          path: '/content',
          name: '内容管理',
          component: resolve => require(['@/components/content/content'], resolve)
        },
        {
          path: '/addContent',
          name: '内容新增',
          component: resolve => require(['@/components/addContent/addContent'], resolve)
        },
        {
          path: '/editContent',
          name: '内容编辑',
          component: resolve => require(['@/components/editContent/editContent'], resolve)
        },
        {
          path: '/action',
          name: '运动库管理',
          component: resolve => require(['@/components/action/action'], resolve)
        },
        {
          path: '/view',
          name: '意见反馈',
          component: resolve => require(['@/components/view/view'], resolve)
        },
        {
          path: '/exercise',
          name: '运动处方',
          component: resolve => require(['@/components/exercise/exercise'], resolve)
        },
        {
          path: '/easyUp',
          name: '易提升人群',
          component: resolve => require(['@/components/easyUp/easyUp'], resolve)
        },
        {
          path: '/easyDown',
          name: '易下降人群',
          component: resolve => require(['@/components/easyDown/easyDown'], resolve)
        },
        {
          path: '/testSearch',
          name: '体测助手',
          component: resolve => require(['@/components/testSearch/testSearch'], resolve)
        },
        {
          path: '/weChat',
          name: '用户统计',
          component: resolve => require(['@/components/weChat/weChat'], resolve)
        },
        {
          path: '/history',
          name: '历史趋势',
          component: resolve => require(['@/components/history/history'], resolve)
        },
        {
          path: '/notice',
          name: '系统通知',
          component: resolve => require(['@/components/notice/notice'], resolve)
        },
        {
          path: '/addTice',
          name: '新增通知',
          component: resolve => require(['@/components/addTice/addTice'], resolve)
        },
        {
          path: '/inforMenu',
          name: '资讯菜单',
          component: resolve => require(['@/components/inforMenu/inforMenu'], resolve)
        },
        {
          path: '/addAction',
          name: '运动新增',
          component: resolve => require(['@/components/addAction/addAction'], resolve)
        },
        {
          path: '/editAction',
          name: '运动编辑',
          component: resolve => require(['@/components/editAction/editAction'], resolve)
        },
        {
          path: '/testscores',
          name: '体适能测试',
          component: resolve => require(['@/components/test-scores/test-scores'], resolve)
        },
        {
          path: '/testscoresfive',
          name: '体测成绩',
          component: resolve => require(['@/components/test-scores/test-scores-five'], resolve)
        },
        {
          path: '/testreport',
          name: '体测报告',
          component: resolve => require(['@/components/test-scores/test-report'], resolve)
        },
        {
          path: '/changePerInfo',
          name: '编辑资料',
          component: resolve => require(['@/components/change-per-info/change-per-info'], resolve)
        },
        {
          path: '/changePassword',
          component: resolve => require(['@/components/change-password/change-password'], resolve)
        },
        {
          path: '/changeRole',
          component: resolve => require(['@/components/change-role/change-role'], resolve)
        },
        {
          path: '/staff',
          name: '全部职工',
          component: resolve => require(['@/components/staff/staff'], resolve)
        },
        {
          path: '/roles',
          name: '角色管理',
          component: resolve => require(['@/components/sys-roles/sys-roles'], resolve)
        },
        {
          path: '/users',
          name: '用户管理',
          component: resolve => require(['@/components/sys-users/sys-users'], resolve)
        },
        {
          path: '/region',
          name: '区域管理',
          component: resolve => require(['@/components/sys-region/sys-region'], resolve)
        },
        {
          path: '/schoolManage',
          name: '学校管理',
          component: resolve => require(['@/components/school-manage/school-manage'], resolve)
        },
        {
          path: '/gradeManage',
          name: '年级管理',
          component: resolve => require(['@/components/grade-manage/grade-manage'], resolve)
        },
        {
          path: '/measureLog',
          name: '报告查询',
          component: resolve => require(['@/components/physical-test-report/test-report'], resolve)
        },
        {
          path: '/fms',
          name: '运动能力测试',
          component: resolve => require(['@/components/profiction-test/profiction-test'], resolve)
        },
        {
          path: '/measureLog2',
          name: '报告查询',
          component: resolve => require(['@/components/physical-test-report2/test-report'], resolve)
        },
        {
          path: '/measureLog3',
          name: '报告查询',
          component: resolve => require(['@/components/physical-test-report3/test-report'], resolve)
        },
        {
          path: '/measureLog4',
          name: '报告查询',
          component: resolve => require(['@/components/physical-test-report4/test-report'], resolve)
        },
        {
          path: '/measureLog4-1',
          name: '报告查询',
          component: resolve => require(['@/components/physical-test-report4-1/test-report'], resolve)
        },
        {
          path: '/measureLog5',
          name: '报告查询',
          component: resolve => require(['@/components/physical-test-report5/test-report'], resolve)
        },
        {
          path: '/measureLog6',
          name: '报告查询',
          component: resolve => require(['@/components/physical-test-report6/test-report'], resolve)
        },
        {
          path: '/measureLog7',
          name: '报告查询',
          component: resolve => require(['@/components/physical-test-report7/test-report'], resolve)
        },
        {
          // 第 8 套报告模板(健康报告·体态评估版):"查看报告"打开 report.healthyoung.life/2
          // 通过菜单管理新增菜单指向本路由,再由角色管理分配给指定学校/机构角色
          path: '/measureLog8',
          name: '报告查询',
          component: resolve => require(['@/components/physical-test-report8/test-report'], resolve)
        },
        {
          path: '/classList',
          name: '班级列表',
          component: resolve => require(['@/components/class-list/class-list'], resolve)
        },
        {
          path: '/menu',
          name: '菜单管理',
          component: resolve => require(['@/components/sys-menu/sys-menu'], resolve)
        },
        {
          path: '/classManage',
          name: '分组管理',
          component: resolve => require(['@/components/school-class-manage/school-class-manage'], resolve)
        },
        {
          path: '/gradeInfoManage',
          name: '部门管理',
          component: resolve => require(['@/components/school-grade-manage/school-grade-manage'], resolve)
        },
        {
          path: '/testProject',
          name: '体测项目',
          component: resolve => require(['@/components/school-test-project/school-test-project'], resolve)
        },
        {
          path: '/dataJump',
          name: '原地纵跳',
          component: resolve => require(['@/components/data-jump/data-jump'], resolve)
        },
        {
          path: '/dataHeight',
          name: '身高',
          component: resolve => require(['@/components/data-height/data-height'], resolve)
        },
        {
          path: '/dataWeight',
          name: '体重',
          component: resolve => require(['@/components/data-weight/data-weight'], resolve)
        },
        {
          path: '/dataBMI',
          name: 'BMI',
          component: resolve => require(['@/components/data-BMI/data-BMI'], resolve)
        },
        {
          path: '/dataVital',
          name: '肺活量',
          component: resolve => require(['@/components/data-vital/data-vital'], resolve)
        },
        {
          path: '/dataGrip',
          name: '握力',
          component: resolve => require(['@/components/data-grip/data-grip'], resolve)
        },
        {
          path: '/dataReaction',
          name: '反应能力',
          component: resolve => require(['@/components/data-reaction/data-reaction'], resolve)
        },
        {
          path: '/dataBalance',
          name: '平衡能力',
          component: resolve => require(['@/components/data-balance/data-balance'], resolve)
        },
        {
          path: '/schoolAdmin',
          name: '学校管理',
          component: resolve => require(['@/components/school-admin/school-admin'], resolve)
        },
        {
          path: '/studentAdmin',
          name: '人员管理',
          component: resolve => require(['@/components/student-admin/student-admin'], resolve)
        },
        {
          path: '/studentAdmin2',
          name: '人员管理',
          component: resolve => require(['@/components/student-admin2/student-admin'], resolve)
        },
        {
          path: '/teachDetail',
          name: '教师详情',
          component: resolve => require(['@/components/teacher-detail/teacher-detail'], resolve)
        },
        {
          path: '/teacherAdd',
          name: '教师添加',
          component: resolve => require(['@/components/teacher-add/teacher-add'], resolve)
        },
        {
          path: '/teachAdmin',
          name: '人员管理',
          component: resolve => require(['@/components/teach-admin/teach-admin'], resolve)
        },
        {
          path: '/teachAdminUser',
          name: '人员机构管理',
          component: resolve => require(['@/components/teach-admin-user/teach-admin-user'], resolve)
        },
        {
          path: '/dailyAdmin',
          name: '打卡管理',
          component: resolve => require(['@/components/daily-admin/daily-admin'], resolve)
        },
        {
          path: '/dataRun',
          name: '成绩录入',
          component: resolve => require(['@/components/data-run/data-run'], resolve)
        },
        {
          path: '/reportAdmin',
          name: '分析报告',
          component: resolve => require(['@/components/report-admin/report-admin'], resolve)
        },

        {
          path: '/reportDetail',
          name: '数据详情',
          component: resolve => require(['@/components/report-detail/report-detail'], resolve)
        },
        {
          path: '/reportEcharts',
          name: '历史',
          component: resolve => require(['@/components/eChartsReport/eChartReport'], resolve)
        },
        {
          path: '/dataStats',
          name: '数据统计',
          component: resolve => require(['@/components/data-stats/data-stats'], resolve)
        },
        {
          path: '/march',
          name: '签到管理',
          component: resolve => require(['@/components/march/march'], resolve)
        },
        {
          path: '/information',
          name: '导入学生',
          component: resolve => require(['@/components/infor/information'], resolve)
        },
        {
          path: '/listDetail',
          name: '个人信息',
          component: resolve => require(['@/components/list-detail/listDetail'], resolve)
        },
        {
          path: '/listHistory',
          name: '体侧历史',
          component: resolve => require(['@/components/list-history/listHistory'], resolve)
        },
        {
          path: '/personalData',
          name: '成绩查询',
          component: resolve => require(['@/components/personal-data/personalData'], resolve)
          /*  meta: {
             keepAlive: true
           } */
        },
        {
          path: '/pointMent',
          name: '预约管理',
          component: resolve => require(['@/components/point-ment/pointMent'], resolve)
        },
        {
          path: '/export',
          name: '导出学生',
          component: resolve => require(['@/components/export/export'], resolve)
        },
        {
          path: '/management',
          name: '视力数据',
          component: resolve => require(['@/components/management/management'], resolve)
        },
        {
          path: '/trend',
          name: '趋势分析',
          component: resolve => require(['@/components/trend/trend'], resolve)
        },
        {
          path: '/sheet',
          name: '统计报表',
          component: resolve => require(['@/components/sheet/sheet'], resolve)
        },
        {
          path: '/achievement',
          name: '成绩导入',
          component: resolve => require(['@/components/achievement/achievement'], resolve)
        },
        {
          path: '/equipmentmanagement',
          name: '设备管理',
          component: resolve => require(['@/components/equipmentmanagement/equipmentmanagement'], resolve)
        },
        {
          path: '/devicemanagement',
          name: '测试项目配置',
          component: resolve => require(['@/components/equipmentmanagement/devicemanagement'], resolve)
        },
        {
          path: '/dashboard',
          name: '数据看板',
          component: resolve => require(['@/components/dashboard/dashboard'], resolve)
        }
      ]
    },
    {
      path: '/',
      name: '登录',
      component: resolve => require(['@/components/login/login'], resolve)
    },
    {
      path: '/viewPrescription',
      name: '运动处方',
      component: resolve => require(['@/components/viewPrescription/viewPrescription'], resolve)
    },
    {
      path: '/speech',
      name: '体质监测分析报告',
      component: resolve => require(['@/components/speech/speech'], resolve)
    },
    {
      path: '/report/:id',
      component: resolve => require(['@/components/students/report'], resolve)
    },
    {
      path: '/rescriptionDetail',
      name: '运动处方详情',
      component: resolve => require(['@/components/rescriptionDetail/rescriptionDetail'], resolve)
    },
    {
      path: '/screenReport',
      name: '功能性动作筛查检测报告',
      component: resolve => require(['@/components/screenReport/screenReport'], resolve)
    },
    {
      path: '/screenDisplay',
      name: '数据大屏',
      component: resolve => require(['@/components/dashboard/screenDisplay'], resolve)
    },
    {
      path: '/retrieve-password',
      name: '找回密码',
      component: () => import('@/components/retrieve-password/retrieve-password.vue')
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js